import React, { Component } from 'react';
import * as Progress    from 'react-native-progress';
import * as ImagePicker from 'expo-image-picker';
import { config } from '../../config';
import { StyleSheet, View, TextInput, ActivityIndicator, SafeAreaView, Modal, TouchableWithoutFeedback, Platform, TouchableOpacity, Image, Linking } from 'react-native';
import { Screen, Button, Input, Routes, MediaModal, Icon, Line, Text, Colors }   from '../components';
import { HomePetsList, MessageList } from '../containers';
import { StringUtils, DateUtils } from '../utils';
import ConsultationController from '../controllers/consultationController';
import AuthController         from '../controllers/authController';
import LottieView             from 'lottie-react-native';

import AsyncStorage from '@react-native-async-storage/async-storage';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

class ConsultationLiveVideoScreen_Base extends Component {

  constructor(props) {
    super(props);

    this.state = {
      consultation_id: props.consultation_id,
      back_to_home: props.back_to_home,
      loading_cancel: false,
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.ten_sec_timer);
    clearInterval(this.state._onEverySecond);
  }

  componentDidMount() {
    let care_consultation_id = this.state.consultation_id;
    let back_to_home         = this.state.back_to_home;
    let ten_sec_timer        = setInterval(this._onEveryTenSeconds, 10000);
    let one_sec_timer        = setInterval(this._onEverySecond, 1000);

    this.setState({ loading_consultation: true }, async () => {

      let care_consultation_response = await ConsultationController.getCareConsultationDetails(care_consultation_id);
      let care_consultation          = care_consultation_response.care_consultation_details;
      let user                       = await AuthController.getUser();

      if (care_consultation) {
        let is_resolved       = care_consultation && care_consultation.status   && care_consultation.status === 'RESOLVED' ? true : false;
        let user_phone_number = user && user.phone_number ? user.phone_number : '';

        let video_token_info   = { phone_number: user_phone_number, product_id: care_consultation._id }
        let video_url_response = await ConsultationController.getVideoSessionAccessCodeByUser(video_token_info);

        let access_code = video_url_response && video_url_response.code           ? video_url_response.code.toUpperCase() : '';
        let session_num = video_url_response && video_url_response.session_number ? video_url_response.session_number     : '';
        let video_url   = config.VIDEO_BASE_URL + '/' + session_num + '/' + access_code;

        this.setState({ loading_consultation: false, care_consultation: care_consultation, user: user, is_resolved: is_resolved, ten_sec_timer: ten_sec_timer, user_phone_number: user_phone_number, video_url: video_url })
      } else {
        this.setState({ loading_consultation: false, user: user, ten_sec_timer: ten_sec_timer })
      }
    });
  }

  _onEverySecond = () => {
    if (this.dog_animation && !this.state.dog_animation_started) {
      this.dog_animation.play();
      this.setState({ dog_animation_started: true });
    }
  }

  _onEveryTenSeconds = async () => {
    let care_consultation_id = this.props && this.props.route && this.props.route.params && this.props.route.params.consultation_id ? this.props.route.params.consultation_id : '';

    if (care_consultation_id) {
      let ping_response = await ConsultationController.setLatestLivePingTime({ care_consultation_id });
    }

    if (care_consultation_id) {
      let care_consultation_response = await ConsultationController.getCareConsultationDetails(care_consultation_id);
      let care_consultation          = care_consultation_response.care_consultation_details;

      if (care_consultation) {
        let provider_joined = care_consultation.live_provider_joined === true ? true : false;
        let is_resolved     = care_consultation && care_consultation.status   && care_consultation.status === 'RESOLVED' ? true : false;

        this.setState({ care_consultation: care_consultation, provider_joined: provider_joined, is_resolved: is_resolved });
      }
    }
  }

  render_live_video_section() {
    return (
      <View style={{ padding: 20 }}>
        { this.render_join_video_component() }
        { this.render_loading_component()    }
        { this.render_resolved_component()   }
      </View>
    )
  }

  render_resolved_component = () => {
    if (this.state.is_resolved) {
      return <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: 50 }}>
        <Icon name='check' solid={true} color={Colors.GREEN} size={50} />
        <Text style={{ fontWeight: '500', fontSize: 18, marginTop: 15, marginBottom: 10 }}>Live Video consultation has ended.</Text>
      </View>
    }
  }

  render_join_video_component = () => {
    if (this.state.provider_joined && !this.state.is_resolved) {
      return <View style={{ justifyContent: 'center', alignItems: 'center', marginTop: 50 }}>
        <Icon name='check-circle' solid={true} color={Colors.GREEN} size={50} />
        <Text style={{ fontWeight: '500', fontSize: 18, marginTop: 15, marginBottom: 10 }}>Provider has entered the room</Text>
        <Button title='Enter Video Room'
                style={{ width: 300 }}
                onPress={ () => {
                  let video_url = this.state.video_url;
                  Linking.openURL(video_url)
                }}/>
      </View>
    }
  }

  render_loading_component = () => {
    if (!this.state.provider_joined && !this.state.is_resolved) {
      let is_mobile = Platform.OS === 'ios' || Platform.OS === 'android' ? true : false;

      return <View style={{ justifyContent: 'center', alignItems: 'center' }}>
        <Image style={{ width: 200, height: 130}} resizeMode='contain' source={require('../assets/animations/cat-tail-wagging.gif')} />
        <Text style={{ fontWeight: '500', fontSize: 18 }}>Waiting for provider...</Text>
        <Text style={{ color: 'grey', textAlign: 'center', fontSize: 16, marginTop: 5 }}>Please remain on this screen, leaving the screen or closing the app will end the Live Video session.</Text>
        { this.render_exit_section() }
      </View>
    }
  }

  render_exit_section = () => {
    if (this.state.display_exit) {
      return <View>
        <Text style={{ fontSize: 16, marginTop: 20, marginBottom: 10, textAlign: 'center' }}>Are you sure you would like to cancel this question? You will be removed from the queue.</Text>
        <Button title='Cancel & Exit'
                style={{ }}
                loading={this.state.loading_cancel}
                onPress={ () => {
                  let care_consultation_id = this.state.consultation_id;

                  let request_data = {
                    care_consultation_id: care_consultation_id,
                  }

                  this.setState({ loading_cancel: true }, async () => {
                    let cancel_response = await ConsultationController.cancelVideoConsultation(request_data);

                    if (cancel_response.success === true) {

                    }

                    this.props.navigate(Routes.HOME)

                    this.setState({ loading_cancel: false });
                  });

                }}/>
        <Button title='Continue Waiting'
                style={{ marginTop: 5 }}
                outline={true}
                onPress={ () => {
                  this.setState({ display_exit: false })
                }}/>
      </View>
    } else {
      return <View>
        <Button title='Cancel & Exit'
                style={{ marginTop: 20 }}
                onPress={ () => {
                  this.setState({ display_exit: true })
                }}/>
      </View>
    }
  }

  back_button_action = () => {
    if (this.state.provider_joined) {
      this.props.navigate(Routes.HOME)
    } else {
      this.setState({ display_exit: !this.state.display_exit })
    }
  }

  // <Screen navigation={this.props.navigation} scroll={true} title='Live Video' back_to_home={this.state.back_to_home} style={{ backgroundColor: 'white' }}>

  render() {
    return (
      <Screen navigation={this.props.navigation} scroll={true} title='Live Video' back_to_home={this.state.back_to_home} bg_white={true} left_action={ () => { this.back_button_action() }}>
        { this.render_live_video_section() }
      </Screen>
    );
  }
}

function ConsultationLiveVideoScreen(props) {
  if(Platform.OS === 'web') {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    let consultation_id = searchParams.get('consultation_id');
    let back_to_home    = searchParams.get('back_to_home');
    return  <ConsultationLiveVideoScreen_Base {...props} consultation_id={consultation_id} back_to_home={back_to_home} location={location} navigate={navigate} />
  } else {
    let params = props.route.params;

    let consultation_id = params.consultation_id;
    let back_to_home    = params.back_to_home;

    return  <ConsultationLiveVideoScreen_Base {...props} consultation_id={consultation_id} back_to_home={back_to_home} navigate={props.navigation.navigate} />
  }
}

const styles = StyleSheet.create({

});

export default ConsultationLiveVideoScreen
